module.exports = __webpack_public_path__ + "static/logo-e95c10ca97eeaebe8a3e78e7b523c7c2.svg";